import './styles.scss';
import './gallery.scss';
import './modal-form';
import Swiper from 'swiper';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', function () {
  const swiperElement = document.querySelector('[data-swiper-gallery]');
  if (!swiperElement) {
    return;
  }

  new Swiper(swiperElement, {
    slidesPerView: 'auto',
    watchOverflow: true,
    freeMode: true,
    freeModeMomentumRatio: 0.8,
    freeModeMomentumVelocityRatio: 0.8,
    breakpoints: {
      1024: {
        noSwipingClass: 'noClass',
      },
    },
  });
});
